import { FieldProps } from 'formik';
import * as React from 'react';
import { string } from 'yup';
import ErrorTextField from './ErrorTextField';

interface FormFieldProps extends FieldProps {
	required?: boolean;
}

const PrimaryPhoneNumber: React.StatelessComponent<FormFieldProps> = function (props) {
	const {
		form: { errors, touched },
		field,
		required,
	} = props;
	const name = field.name;

	return <ErrorTextField
		errorMessage={touched[name] ? errors[name] as string : undefined}
		label={'Primary Phone Number'}
		maskPattern={[ /[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ]}
		required={required}
		type='tel'
		{...field}
	/>;
};

export function primaryPhoneNumberValidation (required: boolean = false) {
	const value = string().matches(/\d{3}([-])\d{3}([-])\d{4}/, 'Please enter a valid phone number.');

	if (required) {
		return value.required('Please enter a phone number.');
	}

	return value;
}

export default PrimaryPhoneNumber;
